<script>
import baseList from "@/views/components/base/baseConsumable.vue";
import { Tag, Button } from "view-design";
import Vue from "vue";
import config from "@/../config";
import Check from "./check.vue";
import Claim from "./claim.vue";
import Stock from "./stock.vue";
import CheckList2 from "./checkList2.vue";
import ImportTemplate from "@/views/components/common/form/consumablesImportTemplate.vue";
import CheckList from "./checkList.vue";
import logo from "../../assets/logo.png";
import QuoteVue from "./quote.vue";
import { IMAGE_HOST } from "@/../config";
let customerId = window.localStorage.getItem("customerId");
export default {
  extends: baseList,
  components: {
    Check,
    Claim,
    Stock,
    QuoteVue,
  },
  data() {
    return {
      table: {
        mname: "consumables",
        key: "id",
        url: {
          list: "/admin/system/inventory/listAdmin",
        },
        output: false,
      },
      selectedConsumable: [],
      tabList: [],
      actions: [
        {
          label: "返回本地仓",
          onClick: this.toBack,
          auth: "",
          type: "info",
          show: "yes",
        },
        {
          label: "引用",
          onClick: this.toCheckList2,
          auth: "",
          type: "info",
          show: "yes",
        },
      ],
      menus: [],
      filters: [
        {
          label: "型号",
          KeyEnter: this.search,
          name: "model",
          value: "",
          type: "input",
        },
        {
          label: "适用设备",
          KeyEnter: this.search,
          name: "remark",
          value: "",
          type: "input",
        },
        {
          label: "耗材名称",
          KeyEnter: this.search,
          name: "name",
          value: "",
          type: "input",
        },
      ],
      tableCols: [
        {
          type: "selection",
          width: 60,
        },
        {
          title: "货物信息",
          key: "consumableImgUrl",
          minWidth: 400,
          align: "left",
          render: (h, p) => {
            const text = Number(p.row.unitPrice).toFixed(2);
            const text1 = p.row.receiveState == 2 ? "目录外申请" : "目录内物资";
            return (

              <div style="display:flex; width:100%; align-items:center;">
                <el-image
                  v-show={customerId == 174 ? false : true}
                  style="width: 60px; height: 60px;flex-shrink: 0;"
                  src={
                    p.row.consumableImgUrl == "" || p.row.consumableImgUrl == null
                      ? logo
                      : IMAGE_HOST + p.row.consumableImgUrl
                  }
                  preview-src-list={[
                    p.row.consumableImgUrl == "" || p.row.consumableImgUrl == null
                      ? logo
                      : IMAGE_HOST + p.row.consumableImgUrl,
                  ]}
                >
                  {" "}
                  <div slot="error" class="image-slot">
                    <img src={logo} />
                  </div>
                </el-image>
                <div style="flex: 1; margin-left: 10px;overflow: hidden;">
                  <div>{customerId == 174 ? null : p.row.brand} {p.row.name} {p.row.model}</div>
                  <el-tooltip class="item" effect="dark" content={p.row.remark} placement="top-start">
                    <div style="width: 100%; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;"
                    >{p.row.remark}</div>
                  </el-tooltip>
                  <div>{p.row.performanceParameter}</div>
                  {/* <div><span><modalAmendVue
                    text={text}
                    item={p.row}
                    priceType="unitPrice"
                    onReset={() => {
                      this.search();
                    }}
                  /></span><div><typeofrequisitionVue
                    text={text1}
                    item={p.row}
                    onReset={() => {
                      this.search();
                    }}
                  /></div></div> */}
                </div>
              </div>
            );
          },
        },
        {
          title: "单价",
          key: "unitPrice",
          width: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = Number(row.unitPrice).toFixed(2);
            return <span style={{ "font-size": "14px" }} >{text}</span>;
          },
        },
        {
          title: "库存",
          key: "num",
          width: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.num;
            return h(
              "div",
              {
                style: {
                  color: row.num <= 10 ? "red" : "",
                  "font-size": "14px",
                  overflow: "hidden",
                  "text-overflow": "ellipsis",
                  "white-space": "nowrap",
                },
              },
              text
            );
          },
        },
        {
          title: "领用类型",
          width: 120,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.receiveState == 2 ? "目录外申请" : "目录内物资";
            return <span>{text}</span>;
          },
        },
        // {
        //   title: "产品条码",
        //   key: "productBarcode",
        //   width: 140,
        //   align: "center",
        //   tooltip: "true",
        // },
        // {
        //   title: "性能参数",
        //   key: "performanceParameter",
        //   minWidth: 240,
        //   align: "left",
        //   tooltip: "true",
        // },
        {
          title: "操作",
          align: "center",
          width: 100,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              return (
                <Button
                  v-show={currentRow.introduceState == 1 ? false : true}
                  size="small"
                  onClick={() => this.onQuote(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginLeft: "5px",
                  }}
                >
                  引用
                </Button>
              );
            },
            /* (vm, h, currentRow, param) => {
              return (
                <Button
                  v-show={currentRow.introduceState == 1 ? true : false}
                  size="small"
                  onClick={() => this.toCheck1(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginLeft: "5px",
                  }}
                >
                  采购申请
                </Button>
              );
            }, */
          ],
        },
      ],
    };
  },
  created() {
    this.loadLevelData();
    if (customerId == 174) {
      this.tableCols = this.tableCols.filter(item => item.key !== 'unitPrice');
    }
  },
  methods: {
    toBack() {
      $utils.url.go(-1);
    },
    //选中
    handleSelect(selected) {
      let ids_arr = [];
      for (let index = 0; index < selected.length; index++) {
        const element = selected[index];
        let consumableIn = {};
        consumableIn.inventoryId = element.id;
        consumableIn.consumableNum = element.consumableNum;
        consumableIn.consumableImgUrl = element.consumableImgUrl;
        consumableIn.brand = element.brand;
        consumableIn.name = element.name;
        consumableIn.model = element.model;
        consumableIn.remark = element.remark;
        consumableIn.typeId = element.typeId;
        consumableIn.receiveState = element.receiveState;
        consumableIn.num = element.num;
        consumableIn.unit = element.unit;
        consumableIn.unitPrice = element.unitPrice;
        consumableIn.introduceState = element.introduceState;
        consumableIn.consumableUuid = element.consumableUuid;
        consumableIn.ownNum = element.ownNum;
        consumableIn.receiveNum = 1;
        ids_arr.push(consumableIn);
      }
      this.selectedConsumable = ids_arr;
    },
    everyType(e) {
      this.selectedConsumable = [];
      this.query.typeId = e;
      this.$refs.tablelist.init();
    },
    loadLevelData() {
      // 通过pk查询字典数据
      let q = { isParent: 1 };
      $utils.api.load("/admin/system/consumableType/selectListAdmin", q).then((res) => {
        if (res && res.rows) {
          this.tabList = res.rows;
        }
      });
    },
    //批量采购
    toCheckList1() {
      if (!this.selectedConsumable.length > 0) {
        return $utils.toast.error("请选择耗材!");
      }
      for (let i = 0; i < this.selectedConsumable.length; i++) {
        const item = this.selectedConsumable[i];
        if (item.introduceState == 2) {
          return $utils.toast.error("有耗材未引用,请先引用!");
        }
      }
      this.$Modal.success({
        closable: true,
        title: "批量采购",
        width: "1100px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <CheckList2
              style={{ margin: "0", color: "#19be6b" }}
              consumableInventory={this.selectedConsumable}
            ></CheckList2>
          );
        },
      });
    },
    toCheckList2() {
      if (!this.selectedConsumable.length > 0) {
        $utils.toast.error("请选择耗材!");
        return;
      }
      for (let i = 0; i < this.selectedConsumable.length; i++) {
        const item = this.selectedConsumable[i];
        if (item.introduceState == 1) {
          $utils.toast.error("有耗材已引用,请取消选择!");
          return;
        }
      }
      let q = this.selectedConsumable;
      q.forEach((item) => {
        item.num = 0;
        item.id = null;
      });
      $utils.api.load("/admin/system/inventory/addAdmin", q, "POST").then((res) => {
        if (res.code == 200) {
          $utils.toast.success("引用成功");
          this.search();
        }
      });
    },

    //单个采购
    toCheck1(row) {
      this.$Modal.remove();
      setTimeout(() => {
        let consumableIn = {};
        consumableIn.inventoryId = row.id;
        consumableIn.consumableNum = row.consumableNum;
        consumableIn.consumableImgUrl = row.consumableImgUrl;
        consumableIn.brand = row.brand;
        consumableIn.name = row.name;
        consumableIn.model = row.model;
        consumableIn.remark = row.remark;
        consumableIn.num = row.num;
        consumableIn.unit = row.unit;
        consumableIn.receiveNum = 1;
        consumableIn.introduceState = row.introduceState;
        consumableIn.consumableUuid = row.consumableUuid;
        consumableIn.unitPrice = row.unitPrice;
        consumableIn.ownNum = row.ownNum;
        let consumableInventory = [];
        consumableInventory.push(consumableIn);
        this.$Modal.success({
          closable: true,
          title: "采购",
          okText: "取消",
          width: "1100px",
          showOk: false,
          render: (h) => {
            return (
              <CheckList2
                style={{ margin: "0", color: "#19be6b" }}
                consumableInventory={consumableInventory}
              ></CheckList2>
            );
          },
        });
      }, 300);
    },
    toStock(row) {
      this.$Modal.success({
        closable: true,
        title: "库存管理",
        width: "750px",
        height: "120px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Stock style={{ margin: "0", color: "#19be6b" }} inventoryId={row.id}></Stock>
          );
        },
      });
    },
    onQuote(row) {
      let q = row;
      q.num = 0;
      q.id = null;
      let d = [];
      d.push(q);
      $utils.api.load("/admin/system/inventory/addAdmin", d, "POST").then((res) => {
        if (res.code == 200) {
          $utils.toast.success("引用成功");
          this.search();
        }
      });
    },
    onClose() {
      $utils.toast.success("引用成功");
      this.$Modal.remove();
      this.search();
      $utils.url.push({ name: "consumables_list" });
    },
    toCheck(row) {
      this.$Modal.success({
        closable: true,
        title: "领用记录",
        width: "1000px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Check style={{ margin: "0", color: "#19be6b" }} inventoryId={row.id}></Check>
          );
        },
      });
    },
    toAdd() {
      $utils.url.push({ name: "consumables_add", query: { action: "add" } });
    },
    handleEdit(currentRow) {
      $utils.url.push({
        name: "consumables_edit",
        query: { action: "edit", kv: currentRow.id },
      });
    },
    //导入
    toImport() {
      this.$Modal.success({
        closable: true,
        title: "导入模板",
        width: "1200px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <ImportTemplate
              style={{ margin: "0", color: "#19be6b" }}
              refListTable={() => {
                this.search();
              }}
            ></ImportTemplate>
          );
        },
      });
    },
    toCheckList() {
      if (!this.selectedConsumable.length > 0) {
        return $utils.toast.error("请选择耗材!");
      }
      this.$Modal.success({
        closable: true,
        title: "批量领用",
        width: "1000px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <CheckList
              style={{ margin: "0", color: "#19be6b" }}
              consumableInventory={this.selectedConsumable}
            ></CheckList>
          );
        },
      });
    },
    //下载模板
    toDownload() {
      window.location.href =
        config.API_HOST + `/admin/system/inventory/template/download`;
    },
  },
};
</script>
<style scoped></style>
